import React, { useEffect } from 'react'
import { BodyText, InvestmentColTwoSpanReverse, LeftColSection, RightColSection } from '../investment/Investment.styles'
import { LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const TargetGoal = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  return (
    <SavingsWrapper>
         <SavingsHeader>
            <LeftSection>
            <h3>
                    Target goal savings smartly designed to make 
                    easily hitting target goals seamlessly possible
            </h3>
            </LeftSection>
            <RightSection>
                <img src="img/Frame 2.svg" alt="" />
            </RightSection>
        </SavingsHeader>
        <InvestmentColTwoSpanReverse>
        <LeftColSection>
          <BodyText>
                This plan enables you save consistently towards a course e.g 
                rents, gadgets,equipments e.t.c. it’s been premeditatedly 
                designed to spur you into a committed saving discipline, you 
                are required to activate the plan with #20,000 just to push you 
                towards hitting target goal. For instance you want to save to buy 
                a phone worth #200,000 then starting with #20,000 will be a smart 
                push for you. It can be activated for you, activated by you and you 
                can as well activate for someone else while you can still receive fund 
                transfer into the savings plan, so you can quickly hit your target goals.

          </BodyText>
        </LeftColSection>
        <RightColSection>
            <img src="img/Group 8624.svg" alt="humaan hands carrying a bag of money" />
        </RightColSection>
      </InvestmentColTwoSpanReverse>
    </SavingsWrapper>

  )
}
